// 个人中心 - 我的发票
import axios from "../../../untils/request.js";

// 我的发票查看发票统计（可开/已开金额）
export async function queryInvoiceCount(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/queryInvoiceCount",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票代开发票列表
export async function listCompanyInvoiceIssue(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/listCompanyInvoiceIssue",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 开票记录
export async function listInvoiceAuditRecord(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/listInvoiceAuditRecord",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 开票记录查询单条记录信息(重开发票进行回显)
export async function getInvoiceAuditInfo(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/getInvoiceAuditInfo",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 查看发票相关信息，发票抬头，邮寄地址，电子邮箱地址
export async function getInvoiceHeadAndMailInfo(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/global/company/getInvoiceHeadAndMailInfo",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 获取所属发票抬头列表
export async function getInvoiceHeadSelect(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/getInvoiceHeadSelect",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 代开发票获取默认抬头与地址邮箱信息
export async function getDefaultHeadAndMailInfo(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/getDefaultHeadAndMailInfo",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 批量开发票
export async function batchIssueInvoice(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/batchIssueInvoice",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 重新开票
export async function reIssueInvoice(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/reIssueInvoice",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 新增发票抬头
export async function addInvoiceHead(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/addInvoiceHead",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 编辑发票抬头
export async function editInvoiceHead(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/editInvoiceHead",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 删除发票抬头
export async function deleteInvoiceHead(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/deleteInvoiceHead",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 设置默认发票抬头
export async function setDefaultInvoiceHead(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/setDefaultInvoiceHead",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 添加邮箱地址
export async function addInvoiceMail(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/addInvoiceMail",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 编辑发票邮箱地址
export async function editInvoiceMail(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/editInvoiceMail",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 删除发票邮箱地址
export async function deleteInvoiceMail(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/deleteInvoiceMail",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 设置默认发票邮箱
export async function setDefaultInvoiceMail(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/setDefaultInvoiceMail",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
// 我的发票 添加发票邮寄地址
export async function addInvoiceAddress(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/addInvoiceAddress",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 编辑发票邮寄地址
export async function editInvoiceAddress(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/editInvoiceAddress",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 删除发票邮寄地址
export async function deleteInvoiceAddress(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/deleteInvoiceAddress",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}

// 我的发票 设置默认发票地址
export async function setDefaultInvoiceAddress(data, currentPage, pageSize) {
  const res = await axios({
    method: "post",
    url: "/info/user/setDefaultInvoiceAddress",
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      "Content-Type": "application/json", //设置请求头请求格式为JSON
    },
  });
  return res.data;
}
